export const createWhatsAppMessage = (customer, cart) => {
  // 1. Validación corregida (calle en lugar de domicilio)
  if (!customer.name) throw new Error('El nombre es obligatorio.');
  
  if (customer.deliveryType === 'home') {
    // Cambiamos customer.domicilio por customer.calle que es lo que viene del Form
    if (!customer.calle || !customer.numExt || !customer.cp || !customer.municipio || !customer.estado) {
      throw new Error('Datos de dirección incompletos para envío a domicilio.');
    }
  }

  let msg = `🐝 *NUEVO PEDIDO PAA* 🐝\n\n`;
  msg += `*Cliente:* ${customer.name} ${customer.lastName}\n`;

  if (customer.deliveryType === 'home') {
    msg += `*Tipo:* 🚚 Envío a domicilio\n`;
    // Usamos calle aquí también
    msg += `*Dirección:* ${customer.calle} #${customer.numExt}${customer.numInt ? ', Int: ' + customer.numInt : ''}\n`;
    if (customer.colonia) msg += `*Colonia/Loc:* ${customer.colonia}\n`;
    msg += `*Municipio:* ${customer.municipio}, ${customer.estado}\n`;
    msg += `*CP:* ${customer.cp}\n`;
    if (customer.referencias) msg += `*Referencias:* ${customer.referencias}\n`;
  } else {
    msg += `*Tipo:* 🏪 Recoger en tienda física\n`;
    if (customer.pickupDate) msg += `*Fecha:* ${customer.pickupDate}\n`;
    if (customer.pickupTime) msg += `*Hora:* ${customer.pickupTime}\n`;
  }

  msg += `\n*Pedido:*\n`;

  let total = 0;
  cart.forEach(item => {
    // Limpieza de precio robusta
    const price = typeof item.price === 'number' 
      ? item.price 
      : parseFloat(item.price.toString().replace(/[^0-9.]/g, '')) || 0;
    
    const qty = item.qty || 1;
    const sub = price * qty;
    total += sub;

    const gramaje = item.cantidad || item.weight || '';
    const aromaStr = item.aroma ? ` - Aroma: ${item.aroma}` : '';
    
    msg += `- ${qty}x ${item.name} ${gramaje ? '('+gramaje+')' : ''}${aromaStr} - *$${sub.toFixed(2)}*\n`;
  });

  msg += `\n*TOTAL: $${total.toFixed(2)} MXN*\n\n_Confirmo mi pedido._`;
  
  // Devolvemos el mensaje limpio (el encoding lo hacemos en la URL)
  return msg;
};

export const getWhatsAppURL = (message) => {
  const whatsappNumber = '523343902273';
  const encodedMessage = encodeURIComponent(message);
  
  /**
   * IMPORTANTE: No uses whatsapp://send. 
   * La API universal https://wa.me/ es mucho más estable.
   * Si detecta la App instalada, la abre. Si no, abre WhatsApp Web.
   */
  return `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
};